import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AUTH_URL } from '../../constants/api';
import IUser from '../../types/user.type';

interface OAuthRedirectProps {
  updateUserState: (user: IUser) => void;
}


const OAuthRedirect: React.FC<OAuthRedirectProps> = ({ updateUserState }) => {
  const navigate = useNavigate();

  useEffect(() => {
  console.log("OAuthRedirect mounted!");
  console.log("Current path:", window.location.pathname);

  // 🔧 Jeśli korzystasz z HashRoutera
  const queryString = window.location.hash.split('?')[1];
  const params = new URLSearchParams(queryString);
  const token = params.get('token');

  console.log("Extracted token:", token);

  if (!token) {
    console.log("No token found, navigating to /login");
    navigate('/login');
    return;
  }

  axios.get(AUTH_URL + 'me', { headers: { Authorization: `Bearer ${token}` } })
    .then(res => {
      console.log("✅ Response received:", res.data);

      const data = res.data;
      const user = {
        accessToken: token,
        id: data.id,
        username: data.username,
        email: data.email,
        roles: data.roles
      };
      localStorage.setItem('user', JSON.stringify(user));
      updateUserState(user);

      if (user.roles.includes('ROLE_USER')) navigate('/training');
      else if (user.roles.includes('ROLE_TRAINER')) navigate('/programs');
      else navigate('/profile');
    })
    .catch(err => {
      console.error(err);
      navigate('/login');
    });
}, []);

  return <div>Signing you in...</div>;
};

export default OAuthRedirect;
